export function initDataLayer() {
    console.log('Tags loaded');

    //TAGS MENU

    const linksMenu = document.querySelectorAll('.header .menu-item a');

    linksMenu.forEach(link => {
        link.addEventListener('click', function () {
            const linkLabel = link.innerText.trim();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gaevent',
                'eventcategory': 'menu',
                'eventaction': 'click',
                'eventlabel': linkLabel
            });
        });
    });

    const linksSocial = document.querySelectorAll('.header .nav__social a');

    linksSocial.forEach(linkSocial => {
        linkSocial.addEventListener('click', function () {
            const linkSocialLabel = linkSocial.innerText.trim();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gaevent',
                'eventcategory': 'menu',
                'eventaction': 'click',
                'eventlabel': linkSocialLabel
            });
        });
    });

    //BANNER HERO

    const homeBannerHero = document.querySelectorAll('.home .banner-hero .banner-hero__bt');

    if(homeBannerHero) {

        homeBannerHero.forEach(linkHero => {
            linkHero.addEventListener('click', function () {
                const linkHeroLabel = linkHero.innerText.trim();

                console.log(linkHeroLabel);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'gaevent',
                    'eventcategory': 'banner',
                    'eventaction': 'click',
                    'eventlabel': linkHeroLabel
                });
            });
        });
    }

    //EVENTOS HOME

    const homeComeceSaiba = document.querySelector('.home-comece-saiba');

    if(homeComeceSaiba) {

        homeComeceSaiba.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'home-comece_por_aqui' ,
                'eventaction' : 'click',
                'eventlabel' : 'Saiba mais'
            })
        });
    }

    const carrosselProjetos = document.querySelectorAll('.home .wp-block-lazyblock-destaque-projetos .carrossel-hover-card');

    if(carrosselProjetos) {

        carrosselProjetos.forEach(cardProjetos => {
            cardProjetos.addEventListener('click', function () {
                const cardProjetoLabel = cardProjetos.querySelector('h4').innerText.trim();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'home-programas_projetos' ,
                    'eventaction' : 'click',
                    'eventlabel': cardProjetoLabel
                });
            });
        });
    }

    const homeLivroEditora = document.querySelector('.home .destaque-editora-card--01 .destaque-editora-card__btn');

    if(homeLivroEditora) {

        homeLivroEditora.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'home-indicacoes_editora' ,
                'eventaction' : 'click',
                'eventlabel' : 'Saiba Mais'
            })
        });
    }

    const homeSiteEditora = document.querySelector('.home .destaque-editora-card--02 .destaque-editora-card__btn');

    if(homeSiteEditora) {

        homeSiteEditora.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'home-indicacoes_editora' ,
                'eventaction' : 'click',
                'eventlabel' : 'Veja o Site'
            })
        });
    }

    const homeFilosofia = document.querySelector('.home-filosofia');

    if(homeFilosofia) {

        homeFilosofia.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'home-filosofia' ,
                'eventaction' : 'click',
                'eventlabel' : 'Saiba Mais'
            })
        });
    }

    const homeBtsNovidades = document.querySelectorAll('.home .bloco-novidades .btn');

    if(homeBtsNovidades){
        homeBtsNovidades.forEach(homeBtNovidades => {
            homeBtNovidades.addEventListener('click', function () {
                const homeBtNovidadesLink = homeBtNovidades.href;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'home-novidades' ,
                    'eventaction' : 'click',
                    'eventlabel' : 'Ver Tudo',
                    'eventurl' : homeBtNovidadesLink
                })
            });
        })
    }

    const homeCardsNovidades = document.querySelectorAll('.home .bloco-novidades .post-card__link');

    if(homeCardsNovidades) {
        homeCardsNovidades.forEach(homeCardNovidades => {
            homeCardNovidades.addEventListener('click', function () {
                const homeCardNovidadesLink = homeCardNovidades.href;
                const homeCardNovidadesTxt = homeCardNovidades.closest('.post-card__txt').querySelector('h3').innerText.trim();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'home-novidades' ,
                    'eventaction' : 'click',
                    'eventlabel' : homeCardNovidadesTxt,
                    'eventurl' : homeCardNovidadesLink
                })
            });
        })
    }

    //TAGS FOOTER 

    const linksSocialFooter = document.querySelectorAll('.footer .footer-social__ico');

    linksSocialFooter.forEach(linkSocialFooter => {
        linkSocialFooter.addEventListener('click', function () {
            const linkSocialFooterLabel = linkSocialFooter.innerText.trim();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'rodape' ,
                'eventaction' : 'click',
                'eventlabel': linkSocialFooterLabel
            });
        });
    });

    const linksFooter = document.querySelectorAll('.footer .menu-item a');

    linksFooter.forEach(linkFooter => {
        linkFooter.addEventListener('click', function () {
            const linkFooterLabel = linkFooter.innerText.trim();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'rodape' ,
                'eventaction' : 'click',
                'eventlabel': linkFooterLabel
            });
        });
    });

    //COMECE POR AQUI 

    const comeceBSGI = document.querySelector('.comece-BSGI');

    if(comeceBSGI){

        comeceBSGI.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'comece_por_aqui-o_que_e_BSGI' ,
                'eventaction' : 'click',
                'eventlabel' : 'Saiba Mais'
            })
        });
    }

    const comeceBudismo = document.querySelector('.comece-budismo');

    if(comeceBudismo) {

        comeceBudismo.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'comece_por_aqui-o_que_o_budismo' ,
                'eventaction' : 'click',
                'eventlabel' : 'Saiba Mais'
            })
        });
    }

    const carrosselProjetosComece = document.querySelectorAll('.page-id-50 .wp-block-lazyblock-destaque-projetos .carrossel-hover-card');

    if(carrosselProjetosComece){
        carrosselProjetosComece.forEach(cardProjetos => {
            cardProjetos.addEventListener('click', function () {
                const cardProjetoLabel = cardProjetos.querySelector('h4').innerText.trim();

                console.log(cardProjetoLabel);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'comece_por_aqui-programas_projetos' ,
                    'eventaction' : 'click',
                    'eventlabel': cardProjetoLabel
                });
            });
        });
    }

    const comeceBtsFaq = document.querySelectorAll('.page-id-50 .destaque-faq .btn');

    if(comeceBtsFaq){
        comeceBtsFaq.forEach(comeceBtFaq => {
            comeceBtFaq.addEventListener('click', function () {

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'comece_por_aqui-faq' ,
                    'eventaction' : 'click',
                    'eventlabel' : 'Saiba Mais'
                })
            });
        })
    }

    const comecePerguntasFaq = document.querySelectorAll('.page-id-50 .destaque-faq .destaque-faq__duvida');

    if(comecePerguntasFaq){
        comecePerguntasFaq.forEach(comecePerguntaFaq => {
            comecePerguntaFaq.addEventListener('click', function () {
                const comecePerguntaFaqLabel = comecePerguntaFaq.querySelector('h4').innerText.trim();

                console.log(comecePerguntaFaqLabel);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'comece_por_aqui-faq' ,
                    'eventaction' : 'click',
                    'eventlabel': comecePerguntaFaqLabel
                });
            });
        });
    }

    const comeceLivroEditora = document.querySelector('.page-id-50 .destaque-editora-card--01 .destaque-editora-card__btn');

    if(comeceLivroEditora) {

        comeceLivroEditora.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'comece_por_aqui-indicacoes_editora' ,
                'eventaction' : 'click',
                'eventlabel' : 'Saiba Mais'
            })
        });
    }

    const comeceSiteEditora = document.querySelector('.page-id-50 .destaque-editora-card--02 .destaque-editora-card__btn');

    if(comeceSiteEditora) {

        comeceSiteEditora.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'comece_por_aqui-indicacoes_editora' ,
                'eventaction' : 'click',
                'eventlabel' : 'Veja o Site'
            })
        });
    }

    //SOBRE NÓS 

    const sobreComece = document.querySelector('.sobre-comece');

    if(sobreComece){

        sobreComece.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'sobre_nos-comece_por_aqui' ,
                'eventaction' : 'click',
                'eventlabel' : 'saiba mais'
            })
        });
    }

    const sobreFundador = document.querySelector('.sobre-fundador');

    if(sobreFundador){

        sobreFundador.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'sobre_nos-lideranca_fundador' ,
                'eventaction' : 'click',
                'eventlabel' : 'ler mais'
            })
        });
    }

    const sobreHistoria = document.querySelector('.sobre-historia');

    if(sobreHistoria){

        sobreHistoria.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'sobre_nos-lideranca_fundador' ,
                'eventaction' : 'click',
                'eventlabel' : 'ler mais'
            })
        });
    }

    const sobreCultura = document.querySelector('.sobre-cultura');

    if(sobreCultura){

        sobreCultura.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'sobre_nos-cultura_cidadania' ,
                'eventaction' : 'click',
                'eventlabel' : 'ler mais'
            })
        });
    }

    //FILOSOFIA 

    const filosofiaPrincipios = document.querySelector('.filosofia-principios');

    if(filosofiaPrincipios){

        filosofiaPrincipios.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'filosofia-principios_conceitos' ,
                'eventaction' : 'click',
                'eventlabel' : 'leia mais'
            })
        });
    }

    const filosofiaEstado = document.querySelector('.filosofia-estado');

    if(filosofiaEstado){

        filosofiaEstado.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'filosofia-principios_conceitos' ,
                'eventaction' : 'click',
                'eventlabel' : 'saiba mais'
            })
        });
    }

    const filosofiaConceitos = document.querySelector('.filosofia-conceito');

    if(filosofiaConceitos){

        filosofiaConceitos.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'filosofia-principios_conceitos' ,
                'eventaction' : 'click',
                'eventlabel' : 'entenda os principais conceitos'
            })
        });
    }

    const filosofiaBtsFaq = document.querySelectorAll('.page-id-103 .destaque-faq .btn');

    if(filosofiaBtsFaq){
        filosofiaBtsFaq.forEach(filosofiaBtFaq => {
            filosofiaBtFaq.addEventListener('click', function () {

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'filosofia-faq' ,
                    'eventaction' : 'click',
                    'eventlabel' : 'Saiba Mais'
                })
            });
        })
    }

    const filosofiaPerguntasFaq = document.querySelectorAll('.page-id-103 .destaque-faq .destaque-faq__duvida');

    if(filosofiaPerguntasFaq){
        filosofiaPerguntasFaq.forEach(filosofiaPerguntaFaq => {
            filosofiaPerguntaFaq.addEventListener('click', function () {
                const filosofiaPerguntaFaqLabel = filosofiaPerguntaFaq.querySelector('h4').innerText.trim();

                console.log(filosofiaPerguntaFaqLabel);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'filosofia-faq' ,
                    'eventaction' : 'click',
                    'eventlabel': filosofiaPerguntaFaqLabel
                });
            });
        });
    }

    const filosofiaLivroEditora = document.querySelector('.page-id-103 .destaque-editora-card--01 .destaque-editora-card__btn');

    if(filosofiaLivroEditora) {

        filosofiaLivroEditora.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'filosofia-indicacoes_editora' ,
                'eventaction' : 'click',
                'eventlabel' : 'Saiba Mais'
            })
        });
    }

    const filosofiaSiteEditora = document.querySelector('.page-id-103 .destaque-editora-card--02 .destaque-editora-card__btn');

    if(filosofiaSiteEditora) {

        filosofiaSiteEditora.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'filosofia-indicacoes_editora' ,
                'eventaction' : 'click',
                'eventlabel' : 'Veja o Site'
            })
        });
    }

    //EDUCACAO 

    const educacaoColegio = document.querySelector('.educacao-colegio');

    if(educacaoColegio){

        educacaoColegio.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'educacao_soka' ,
                'eventaction' : 'click',
                'eventlabel' : 'saiba mais'
            })
        });
    }

    //SUSTENTABILIDADE 

    const sustentInstituto = document.querySelector('.sustent-instituto');

    if(sustentInstituto){

        sustentInstituto.addEventListener('click', function () {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'gaevent' ,
                'eventcategory' : 'sustetabilidade' ,
                'eventaction' : 'click',
                'eventlabel' : 'saiba mais'
            })
        });
    }

    //NOVIDADES

    const novidadesBannerHero = document.querySelectorAll('.blog .banner-hero .banner-hero__bt');

    if(novidadesBannerHero) {

        novidadesBannerHero.forEach(linkHero => {
            linkHero.addEventListener('click', function () {
                const linkHeroUrl = linkHero.href;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'novidades' ,
                    'eventaction' : 'click',
                    'eventlabel' : 'ler materia' , 
                    'eventlink': linkHeroUrl
                    
                });
            });
        });
    }

    const novidadesCategorias = document.querySelectorAll('.blog #boxFiltros .cat-item a');

    if(novidadesCategorias) {

        novidadesCategorias.forEach(novidadesCategoria => {
            novidadesCategoria.addEventListener('click', function () {
                const novidadesCategoriaLabel = novidadesCategoria.innerText.trim();

                console.log(novidadesCategoriaLabel);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'novidades' ,
                    'eventaction' : 'click',
                    'eventlabel' : novidadesCategoriaLabel
                    
                });
            });
        });
    }

    //PUBLICAÇÕES

    const publiCards = document.querySelectorAll('.template-publicacoes .post-card__link');

    if(publiCards) {

        publiCards.forEach(publiCard => {
            publiCard.addEventListener('click', function () {
                const publiCardUrl = publiCard.href;
                const publiCardTxt = publiCard.closest('.post-card__txt').querySelector('h3').innerText.trim();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'publicacoes' ,
                    'eventaction' : 'click',
                    'eventlabel' : publiCardTxt ,
                    'eventlink' : publiCardUrl ,
                    
                });
            });
        });
    }

    const publiCategorias = document.querySelectorAll('.template-publicacoes #boxFiltros a');

    if(publiCategorias) {

        publiCategorias.forEach(publiCategoria => {
            publiCategoria.addEventListener('click', function () {
                const publiCategoriaLabel = publiCategoria.innerText.trim();

                console.log(publiCategoriaLabel);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'publicacoes-filtros' ,
                    'eventaction' : 'click',
                    'eventlabel' : publiCategoriaLabel
                    
                });
            });
        });
    }

    const formContato = document.getElementById('formContato');

    if (formContato) {

    formContato.addEventListener('wpcf7mailsent', function (event) {
            const form = event.target;
            const emailInput = form.querySelector('input[type="email"]');
            const userEmail = emailInput ? emailInput.value.trim() : '';

            console.log(userEmail);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'form',
                'eventcategory': 'contato',
                'eventaction': 'formulario',
                'eventlabel': userEmail
            });
        });
    }

    const formTrabalhe = document.getElementById('formTrabalhe');

    if (formTrabalhe) {

    formTrabalhe.addEventListener('wpcf7mailsent', function (event) {
            const form = event.target;
            const emailInput = form.querySelector('input[type="email"]');
            const userEmail = emailInput ? emailInput.value.trim() : '';

            console.log(userEmail);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'form',
                'eventcategory': 'contato',
                'eventaction': 'formulario',
                'eventlabel': userEmail
            });
        });
    }

    const contatoLinksSocial = document.querySelectorAll('.contato-social a');

    if(contatoLinksSocial) {

        contatoLinksSocial.forEach(contatoLinkSocial => {
            contatoLinkSocial.addEventListener('click', function () {
                const contatoLinkSocialLabel = contatoLinkSocial.innerText.trim();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'contato' ,
                    'eventaction' : 'click',
                    'eventlabel': contatoLinkSocialLabel
                });
            });
        });
    }

    const contatoBtsFaq = document.querySelectorAll('.template-contato .destaque-faq .btn');

    if(contatoBtsFaq){
        contatoBtsFaq.forEach(contatoBtFaq => {
            contatoBtFaq.addEventListener('click', function () {

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'contato-faq' ,
                    'eventaction' : 'click',
                    'eventlabel' : 'Saiba Mais'
                })
            });
        })
    }

    const contatoPerguntasFaq = document.querySelectorAll('.template-contato .destaque-faq .destaque-faq__duvida');

    if(contatoPerguntasFaq){
        contatoPerguntasFaq.forEach(contatoPerguntaFaq => {
            contatoPerguntaFaq.addEventListener('click', function () {
                const contatoPerguntaFaqLabel = contatoPerguntaFaq.querySelector('h4').innerText.trim();

                console.log(contatoPerguntaFaqLabel);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'gaevent' ,
                    'eventcategory' : 'contato-faq' ,
                    'eventaction' : 'click',
                    'eventlabel': contatoPerguntaFaqLabel
                });
            });
        });
    }
    
}